<template>
  <div class="nch--blog-card" :class="[{ flat }]"><slot /></div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    flat: {
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.nch--blog-card {
  display: flex;
  justify-content: center;

  padding: min(30px, 3vw);
  background-color: #fff;
  box-shadow: 4px 4px 25px -6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  margin: 1rem;
}
.nch--blog-card.flat{
  border: 1px solid #e8e8e8;
  box-shadow: unset;
}
</style>
